import { render, staticRenderFns } from "./TelemedicineConsultations.vue?vue&type=template&id=7cf568b5&scoped=true&"
import script from "./TelemedicineConsultations.vue?vue&type=script&lang=js&"
export * from "./TelemedicineConsultations.vue?vue&type=script&lang=js&"
import style0 from "./TelemedicineConsultations.vue?vue&type=style&index=0&id=7cf568b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf568b5",
  null
  
)

export default component.exports